import React, { Component } from 'react'
import successLogo from './../../../../../statics/img/tabby_pos/success.svg'
import failLogo from './../../../../../statics/img/tabby_pos/declined.svg'
import pendingLogo from './../../../../../statics/img/tabby_pos/pending.svg'
import './TabbyPos.css'

class TabbyStatus extends Component {
    
    componentDidMount (){
        const myJSON = JSON.stringify(this.props.pos_data);
        setTimeout(()=>{
            // handle close iframe and return to POS
            if(window.androidInterface){
                if(this.props.pos_data.pos_receipt == ""){
                    try{
                        window.androidInterface.cancel_trnx()
                    }catch (e){
                        window.androidInterface.cancel_trnx()
                    }
                }else{
                    try{
                        window.androidInterface.submit_trnx(myJSON)
                    }catch (e){
                        window.androidInterface.submit_trnx(myJSON)
                    }
                } 
            }
        },3000)
    }

    renderSuccess = () => (
        <div>
            <img src={successLogo} />
            <h4 className="success">Accepted</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    renderFail = () => (
        <div>
            <img src={failLogo} />
            <h4 className="declined">Declined</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    renderPending = () => (
        <div>
            <img src={pendingLogo} />
            <h4 className="pending">Pending</h4>
            <p>{this.props.status_message}</p>
        </div>
    )

    render() {
        return (
            <div className="tabby_pos_content tabby_pos_status">
                {this.props.tabby_pos_status == "success" && this.renderSuccess()}
                {this.props.tabby_pos_status == "fail" && this.renderFail()}
                {this.props.tabby_pos_status == "pending" && this.renderPending()}
                {this.props.error &&
                    <div className="tabby_pos_error">
                        {this.props.error_message}
                    </div>
                }
            </div>
        )
    }
}
export default TabbyStatus;